import React, { FC, useMemo } from 'react';
import { format } from 'date-fns';
import { CloseOutlined } from '@ant-design/icons';
import { Drawer } from '@shared/ui/Drawer/Drawer';
import { QCUploadEDTF } from '@shared/types/ImagingSpecialist';
import { EDTFDisplayForm } from '../EDTFForm/EDTFDisplayForm';

type EDTFDrawerProps = {
  edtfData: QCUploadEDTF | null;
  uploadDateTime?: string;
  isOpen: boolean;
  dark?: boolean;
  onClose: () => void;
  siteUserName?: string;
};

export const EDTFDrawer: FC<EDTFDrawerProps> = ({
  uploadDateTime,
  siteUserName,
  isOpen,
  edtfData,
  onClose,
  dark,
}) => {
  const titleClass = dark ? '!text-white' : '';

  const time = useMemo(() => {
    if (!uploadDateTime) {
      return '';
    }

    try {
      return format(new Date(uploadDateTime || ''), 'dd-MMM-YYY HH:mm:ss');
    } catch (e) {
      console.log('Error parsing date', e);
      return '';
    }
  }, [uploadDateTime]);

  return (
    <Drawer
      id={'qc-upload-edtf-drawer'}
      classNames={{
        header: `!px-0 !pb-[8px] !pt-[8px] ml-[10px] mb-2 !border-0 [&_.ant-drawer-close]:absolute [&_.ant-drawer-close]:right-[16px] [&_.ant-drawer-close]:top-[16px]`,
        body: 'flex flex-col !px-0 !pb-0 !pt-[5px]',
        content: `rounded-lg ${dark ? '!bg-darkCharcoal ' : 'bg-white'}`,
      }}
      title={
        <span className={titleClass}>
          eDTF for {time} upload by {siteUserName || 'Unknown User'}
        </span>
      }
      open={!!isOpen}
      width={928}
      onClose={onClose}
      placement="right"
      closeIcon={<CloseOutlined className={dark ? '!text-white' : ''} />}
    >
      {edtfData && (
        <EDTFDisplayForm
          dark={dark}
          data={edtfData}
        />
      )}
    </Drawer>
  );
};
